import {z} from 'zod';
import {ELEMENT} from '../../elements/base/ElementTypes';

const imageValidator = z.object({
    id: z.string(),
    height: z.string(),
    imageSrc: z.string(),
    width: z.string(),
    widthHeightRatio: z.number(),
});

export const imageGalleryValidator = z.object({
    type: z.literal(ELEMENT.IMAGE_GALLERY),
    images: z.array(imageValidator).min(1, {message: 'designSidepanel.imagesRequired'}),
});
